import { useLayoutEffect, useRef } from 'react'

import { useBookingContext } from '@providers/booking'
import { useBookingContinueInternal } from './booking_continue_context'
import type { BookingContinuePolicy } from './types'

export const useBookingContinuePolicy = (policy: BookingContinuePolicy) => {
  const bookingCtx = useBookingContext()
  const { registerPolicy } = useBookingContinueInternal()
  const latestPolicyRef = useRef(policy)
  latestPolicyRef.current = policy

  useLayoutEffect(() => {
    if (policy.owner !== bookingCtx.state.currentState) return

    return registerPolicy({
      owner: policy.owner,
      getPolicy: () => latestPolicyRef.current,
    })
  }, [bookingCtx.state.currentState, policy.owner, registerPolicy])
}
